<template>
  <app-loading-section class="tab-loading-section" :loading="isLoading">
    <stats-team-chart :chart-data="acquisitions"/>
  </app-loading-section>
</template>

<script>
import StatsTeamChart from "./StatsTeamChart.vue";
import utils from "../../../services/utils";
import api from "../../../api";

export default {
  name: "StatsTeamAcquisitions",
  components: {
    StatsTeamChart
  },
  data() {
    return {
      isLoading: true,
      acquisitions: [],
      chartTemplate: {
        label: '',
        total: 0,
        chart: {
          labels: [],
          datasets: [{
            label: '',
            ids: [],
            data: [],
            backgroundColor: [],
            hoverOffset: 4,
            borderWidth: 4,
          }]
        }
      },
    }
  },
  watch: {
    'activeTab' () {
      if (this.activeTab === 'StatsTeamAcquisitions') {
        this.loadStats()
      }
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters['statsTeam/getActiveTab']
    },
    statFilter() {
      return this.$store.getters['statsTeam/getFilters']
    },
    chartBgColors() {
      return this.$store.getters['statsTeam/getChartBackgroundColors']
    },
  },
  methods: {
    loadStats() {
      this.isLoading = true
      this.acquisitions = []

      const data = {
        start_at: this.statFilter.timeFrameValues.start,
        end_at: this.statFilter.timeFrameValues.end,
        users: this.statFilter.users
      }

      Promise.all([
        api.statsTeam.getAppointmentsAssigned(data),
        api.statsTeam.getAppointmentsCancelledByUs(data),
        api.statsTeam.getAppointmentsCancelledByLead(data),
        api.statsTeam.getContracts(data),
        api.statsTeam.getBought(data),
        api.statsTeam.getSold(data),
        api.statsTeam.getProjectedProfit(data),
        api.statsTeam.getActualProfit(data)
      ]).then(([
        resAppointmentsAssigned,
        resAppointmentsCancelledByUs,
        resAppointmentsCancelledByLead,
        resContracts,
        resBought,
        resSold,
        resProjectedProfit,
        resActualProfit
      ]) => {
        this.acquisitions.push(
          this.formatResponse('Appointments Assigned', resAppointmentsAssigned.data),
          this.formatResponse('Appointments Cancelled By Us', resAppointmentsCancelledByUs.data),
          this.formatResponse('Appointments Cancelled By Lead', resAppointmentsCancelledByLead.data),
          this.formatResponse('Contracts', resContracts.data),
          this.formatResponse('Bought', resBought.data),
          this.formatResponse('Sold', resSold.data),
          this.formatResponse('Projected Profit', resProjectedProfit.data, true),
          this.formatResponse('Actual Profit', resActualProfit.data, true)
        )
      })
      .finally(() => this.isLoading = false)
    },
    formatResponse(label, response, isAmount = false) {
      let chartData = utils.clone(this.chartTemplate)

      chartData.label = label
      if (response.length === 0) return chartData

      const total = response.reduce((accumulator, res) => accumulator + res.total, 0)
      chartData.total = total
      if (isAmount) {
        // format as currency and remove decimal
        chartData.total = utils.formatCurrency(total).replace(/[.]\d+$/g, '')
      }

      if (total) {
        chartData.chart.labels = response.map(res => res.user_name)
        chartData.chart.datasets[0].label = label

        response.forEach(res => {
          chartData.chart.datasets[0].ids.push(res.user_id)
          chartData.chart.datasets[0].data.push(res.total)

          const bgColor = this.chartBgColors.find(color => color.userId === res.user_id)
          if (bgColor) {
            chartData.chart.datasets[0].backgroundColor.push(bgColor.color)
          }
        })
      }

      return chartData
    },
  },
}
</script>

<style scoped lang="scss">

</style>
